import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import HeaderLogged from '../../../../../components/header_logged'
import FormEdit from '../../../../../components/auth/institucional/secretaria/listar/form_edit'
import Head from '../../../../../components/head'


function EditarSecretariaScreen () {
    return (
        <Fragment>
            <Head titulo="Editando Secretaria Municipal" />
            <HeaderLogged />
            <Container>
                <FormEdit />
            </Container>
        </Fragment>
    );
}

export default EditarSecretariaScreen;